import type { TModule } from '@modules/core/types';

import { MOVEMENTS_ROUTE_PATHS } from './config';
import { CASHOUT_DEPOSITS_ROUTES } from './cashout-deposits';
import { TRANSFER_ROUTES } from './transfers';
import { DEBIT_CARD_ROUTES } from './debit-card-transactions';
import { PROMO_ROUTES } from './promo';
import { WALLETS_ROUTES } from './wallets';
import { WITHDRAWALS_ROUTES } from './withdrawals';
import { FULL_GATEWAY_ROUTES } from './full-gateway';
import { FULL_GATEWAY_MERCHANT_ROUTES } from './full-gateway-merchant';
import { PLATFORM_TRANSFERS_ROUTES } from './platform-transfers';
import { TOP_UP_ROUTES } from './top-up';
import { PIX_TRANSFERS_ROUTES } from './pix-transfers';

const movementsModule: TModule = {
  id: 'movements',
  fallbackRoute: [MOVEMENTS_ROUTE_PATHS.wallets],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...WALLETS_ROUTES, ...DEBIT_CARD_ROUTES, ...CASHOUT_DEPOSITS_ROUTES, ...PROMO_ROUTES, ...WITHDRAWALS_ROUTES, ...TRANSFER_ROUTES, ...FULL_GATEWAY_ROUTES, ...FULL_GATEWAY_MERCHANT_ROUTES, ...PLATFORM_TRANSFERS_ROUTES, ...TOP_UP_ROUTES, ...PIX_TRANSFERS_ROUTES],
};

export { MOVEMENTS_ROUTE_PATHS as MovementsRoutePaths };

export default movementsModule;
